import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'designing-editing-fun-easy',
  styleUrls: ['../designing.component.scss'],
  templateUrl: './editingFunEasy.component.html',
})
export class DesigningEditingFunEasyComponent {
  @Input() step;
  @Input() totalSteps;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  constructor(public translate: TranslateService) {}

  submit() {
    this.next.emit();
  }
}
